import { NonFieldError } from './NonFieldError';

export default NonFieldError;
